import { render, staticRenderFns } from "./inventario.vue?vue&type=template&id=65416dc8&"
import script from "./inventario.vue?vue&type=script&lang=js&"
export * from "./inventario.vue?vue&type=script&lang=js&"
import style0 from "./inventario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports